import { Button, Row } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

type HeaderProps = {
  title: string;
  accountId: string;
};

export const Header = ({ title, accountId }: HeaderProps) => {
  const navigate = useNavigate();

  const onBack = useCallback(() => navigate(-1), [navigate]);

  return (
    <Row className="w-100 px-8 profile-header align-center">
      <Button
        shape="circle"
        icon={<ArrowLeftOutlined />}
        size="large"
        className="back-btn mr-6"
        onClick={onBack}
      />
      <Row className="d-block">
        <h3 className="h h3">{title}</h3>
        <span className="text-sm title">#{accountId}</span>
      </Row>
    </Row>
  );
};
